import { Component } from '@angular/core';
import { ZiroFormAbstractDirective } from '../../../../forms/ziro-form-abstract.directive';
import { ZiroRadioConfig } from '../../../../forms/fields/radio/ziro-radio.component';
import { Observable, of } from 'rxjs';
import { SamlSsoConfig } from '../../../../shared/models/generated/ziroModels';
import { ZiroFormConfig } from '../../../../forms/ziro-forms-models';

@Component({
  selector: 'ziro-saml-sso-type-form',
  standalone: false,
  templateUrl: 'saml-sso-type-form.component.html',
})
export class SamlSsoTypeFormComponent extends ZiroFormAbstractDirective<SamlSsoConfig> {
  formConfig: ZiroFormConfig = {
    fields: {
      ssoEnabled: {
        label: 'tkey;admin.saml.sso_type.label',
        dataAutomation: 'sso-type-radio',
        componentConfig: new ZiroRadioConfig({
          buttons: [
            { value: false, label: 'tkey;admin.saml.sso_type.oidc' },
            { value: true, label: 'tkey;admin.saml.sso_type.saml' },
          ],
          isDisplayVertical: true,
        }),
      },
    },
  };

  protected submit(): Observable<void> {
    return of(null);
  }
}
